import React from "react";

export const Image = ({ title, largeImage, smallImage, mediumUrl }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a
          href={mediumUrl}
          target="_blank"
          rel="noreferrer"
          title={title}
          data-lightbox-gallery="gallery1"
        >
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img
            src={largeImage}
            className="img-responsive"
            alt={title}
            style={{ margin: "0 auto", maxHeight: "450px", width: "auto" }}
          />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
